import * as React from "react";
import type { PopupPositionsType } from "@skbkontur/react-ui";

export const uiSettingsTourStep = {
    id: "candyform_uisettings",
    header: "Настройте интерфейс формы",
    onBefore: "showPanel",
    onAfter: "hidePanel",
    content: <div>{"Настройте оформление, чтобы удобнее заполнить отчёт"}</div>,
    group: ["panel"],
    positions: ["right middle", "right bottom"] as PopupPositionsType[],
    offset: 20,
    order: 55,
};
